import React from "react";
import Footer from "../components/footer/Footer";
import Navbar from "../components/navbar/Navbar";
import SecondBanner from "../components/second-banner/SecondBanner";
import AboutMe from "../components/about/AboutMe";

const About = () => {
  return (
    <>
      <Navbar />
      <SecondBanner
        head={"About Me"}
        text={
          "I am a full stack developer with 3+ years experience specializing in React, Javascript & Nodejs."
        }
      />
      <AboutMe />
      <Footer />
    </>
  );
};

export default About;
